import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLoadHistoryShowModal } from "../../actions/load";
import LoadHistoryContent from "./LoadHistoryContent";
import "../../../assets/scss/load-history.scss";

const LoadHistoryPopup = () => {
  const showModal = useSelector((state) => state.load.loadHistory.showModal);
  const { farmId, crewId, egId } = useSelector(
    (state) => state.load.loadHistory.params
  );
  const dispatch = useDispatch();

  const getCloseButton = () => {
    return (
      <span
        style={{ color: "gray" }}
        className="close-btn"
        title="close"
        onClick={() => {
          dispatch(setLoadHistoryShowModal(false));
        }}
      >
        <i className="fa fa-times" />
      </span>
    );
  };

  return (
    showModal && (
      <div className={`load-history modal-view`}>
        <LoadHistoryContent
          farmId={farmId}
          crewId={crewId}
          egId={egId}
          closeButton={getCloseButton()}
        />
      </div>
    )
  );
};

export default LoadHistoryPopup;